<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 row p-2 mb-0" [ngClass.sm]="'border-bottom disabled'" *ngIf="!_utilService.isMobile">
        <div class="d-flex col-10" [ngClass.sm]="'mb-075'">
          <div>
            <input type="search" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKey" (ngModelChange)="filterList()" />
          </div>
          <div class="ml-2">
            <select [(ngModel)]="searchApprendistato" (ngModelChange)="filterList()" class="form-control">
              <option [value]="2">{{ "ALL" | translate }}</option>
              <option [value]="1">Apprendistato</option>
              <option [value]="0">Non apprendistato</option>
            </select>
          </div>
        </div>
        <div class="text-right col-2">
          <a routerLink="/dashboard/gestione/costi-contratti/edit" class="btn btn-outline-primary" *ngIf="_authenticationService.hasCapability('manage_contracts_costs')">{{ "UPDATE_COSTS" | translate }}</a>
        </div>
        <div class="col-12 mt-025">
          <span class="text-muted font-small-3" *ngIf="!!lastUpdate">{{ "LAST_UPDATE" | translate }} {{ lastUpdate }}</span>
        </div>
      </div>

      <div class="card-body p-0" *ngIf="_utilService.isDesktop || _utilService.isTablet">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [loadingIndicator]="loadingTable" [rows]="filteredCosts" [headerHeight]="50" [rowHeight]="70" [limit]="searchKey ? 100 : 15" [footerHeight]="50">
          <ngx-datatable-column
            *ngFor="let key of ['level', 'is_apprendistato', 'year', 'salary_yearly_gross', 'total_yearly', 'total_month', 'net_monthly_12', 'net_monthly_13', 'total_daily']"
            [name]="key.toUpperCase() | translate"
            [prop]="key"
            [sortable]="false"
          >
            <ng-template ngx-datatable-cell-template let-row="row">{{ row[key] || 0 }}</ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <div class="card" *ngIf="_utilService.isMobile">
        <h2 class="text-center p-3">{{ "PAGE_NOT_AVAILABLE_FROM_MOBILE" | translate }}</h2>
      </div>
    </div>
  </div>
</div>
